import { useTranslation } from 'react-i18next';
import { useEffect, useState, useRef} from 'react';
import { format } from 'react-string-format';
import { Model } from "survey-core";
import '../../../i18n'
import { APIGet, APIPost } from '../../API/APIRequest';
import SurveyComponent from "ad-web-ui-library";
import { GetADToken } from '../../Utilities/TokenManager';
import './cancelation.scss';
import Button from '../../UI/Buttons/Button';
import { useParams } from 'react-router-dom';
import { GenericErrorBox } from '../../UI/ErrorBox/GenericErrorBox';
 

const CancelationReasons = (props) => {
    const surveyRef = useRef(null);
    const userToken = GetADToken();
    const { t, i18n } = useTranslation();
    const [arrayChoices, setArrayChoices] = useState([]);
    const { handlePageChange} = props;
    const { fid } = useParams();
    const [errors, setErrors] = useState([]);
    const [isLoadingCancel, setIsLoadingCancel] = useState(false);
    const [isLoadingKeep, setIsLoadingKeep] = useState(false);
    const surveyJson = {
        showNavigationButtons: false,
        name: "captureforms",
        showCompletedPage: false,
        showQuestionNumbers: "off",
        questionErrorLocation: "bottom",
        checkErrorsMode: "onValueChanged",


        elements: [
            {
                type: "radiogroup",
                name: "reasons",
                title: `${t('cancelationform.radiobutton.title')}`,
                choices: [
                    {}
                ],
          
                calculatedValues: [
                    {
                        "name": "var1",
                        "expression": "{current-var}",
                        "includeIntoResult": true
                    }
                ]
            },
            {
                type: "comment",
                name: "suggestions",
                title: `${t('cancelationform.commentfield.title')}`,

                textUpdateMode: "onBlur",
                placeHolder: "Write here...",
                rows: 5 // Sets the initial height of the textarea
            },]
    };

    
    if (!surveyRef.current) {
        surveyRef.current = new Model(surveyJson);
        surveyRef.current.showNavigationButtons = false; // we control buttons
     }

    // const survey = surveyRef.current;

    useEffect(() => {

        surveyRef.current.getAllQuestions().forEach(question => {
     
         
            const choices = arrayChoices.filter((item)=> item.name !== "No Reason Given").map((item) => ({
                 value: item.code,
                 text: item.name,
             }));

            if (question.getType() === "radiogroup") {
                 question.choices = choices;
 
             }
        });
    }, [arrayChoices])

  

    useEffect(() => { 
     
        APIGet({
            "controller": "order",
            "action": "stopreasons", 
            "headers": [{
                "key": "UserToken",
                "value": userToken.token ?? ""
            }]
        }).then((response) => {  
    
            let data = response.data.choices; 
            setArrayChoices(data) 
        }) 
        .catch((error) => {
 
            console.log(error)
          
        })
    },[])


    const handleRedirection = () => {
        let returnUrl = sessionStorage.getItem("ReturnUrl");
        window.location.href = returnUrl;
    }
     
    useEffect(() => {
        const survey = surveyRef.current;
        if (!survey) return;
        

        const handleValueChange = (sender) => {
          
            props.onDataChange?.(sender.data); //on chnage of selection this fires
        };

        survey.onValueChanged.add(handleValueChange);
    
        const handleComplete = (sender) => {
            
            props.onDataChange?.(sender.data); //on completion of form this fires
        };
    
        survey.onComplete.add(handleComplete);
    
        return () => {
            survey.onValueChanged.remove(handleValueChange);
            survey.onComplete.remove(handleComplete)};
    }, []);
    
    
return (
    <>
        {errors?.length > 0 && <GenericErrorBox errors={errors}/>}
        <section className="cancellationSection">
            <div className="container">
                <div className="item-container">
                    <div className="item-wrapper text-center">
                        <h2>{t("cancelationform.title")}</h2>
                        <p className="small-text">{t('cancelationform.description')} </p>
                    </div>
                </div>
            <div className="item-container">
                <div className="item-wrapper">
                    <SurveyComponent
                        survey={surveyRef.current}
                    />
                </div>
                </div>
                <div className="item-container">
                    <div class="border-seperator"></div>
                </div>

                <div className="item-container">
                    <div className="item-wrapper one-row">
                      
                        {isLoadingCancel ? <Button type="button" btnType="ghost" buttonSize="medium" hasIcon="updating" >{t('cancelationform.continuetocancelbuttontext')} </Button>
                            : <Button type="button" buttonSize="medium" btnType="ghost" onClick={(e)=>{ handlePageChange("ORDER_CANCELLATION");}} >{t('cancelationform.continuetocancelbuttontext')} </Button>}
                              {isLoadingKeep ? <Button type="button" buttonSize="medium"  hasIcon="updating" >{t('cancelationform.keepsubsbuttontext')}</Button>
                                    :   <Button type="button" buttonSize="medium" onClick={(e) => { handleRedirection(e); setIsLoadingKeep(true); }}>{t('cancelationform.keepsubsbuttontext')}</Button>}
                    </div>
                </div>
            </div>

        </section>
      
    </>  
)
}

export default CancelationReasons;

